import { render, staticRenderFns } from "./DoctorAssist.vue?vue&type=template&id=4452bab9&scoped=true"
import script from "./DoctorAssist.vue?vue&type=script&lang=js"
export * from "./DoctorAssist.vue?vue&type=script&lang=js"
import style0 from "./DoctorAssist.vue?vue&type=style&index=0&id=4452bab9&prod&scoped=true&lang=scss"
import style1 from "./DoctorAssist.vue?vue&type=style&index=1&id=4452bab9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4452bab9",
  null
  
)

export default component.exports